import { i, s, x } from '../../lit-element.js';
import { reset } from '../../styles/reset.style.js';
import { links } from '../../styles/links.style.js';
import { severity } from './utils/constants.js';

const style = i`
  :host {
    display: none;
    font-size: 1em;
  }

  :host([active]) {
    display: block;
    padding-top: 0.4em;
  }

  :host([hidden]) {
    display: none;
  }

  p {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    text-align: left;
  }

  @media (min-width: 48em) {
    .banner-content {
      text-align: center;
    }
  }
`;

class RefiBanner extends s {
  constructor() {
    super();
    this.path = window.location.href;
    this.content = '';
    this.alertType = '';
    this.active = false;
    this.jsonContentEvent = null;
    this.banner = {};
  }

  static get properties() {
    return {
      content: { type: String, reflect: true },
      active: { type: Boolean, reflect: true },
      alertType: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [reset, links, style];
  }

  render() {
    return x`
      <refi-common-alert @refiAlertClose="${this.bannerClosed}" ?show-close="${this.alertType !== 'warning'}" ?active="${this.active}" alert-type="${this.alertType}">
        <refi-common-chariot
          @contentReady="${this.getBanner}"
          content-name="Banners.ecm.json"
          content-path="content.0.blocks"
          list-content-path="sections.0.items"
          content="${this.content}"
        ></refi-common-chariot>
      </refi-common-alert>
    `;
  }

  async connectedCallback() {
    super.connectedCallback();
    let previousUrl = '';
    const observer = new MutationObserver(() => {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href;
        this.path = window.location.href;
        if (this.jsonContentEvent) {
          this.getBanner(this.jsonContentEvent);
        }
      }
    });
    const config = {
      childList: true,
      subtree: true,
    };
    observer.observe(document, config);
  }

  getBanner(event) {
    this.jsonContentEvent = event;
    const bannersArray = this.parseChariotContent(event.detail);
    let activeBanner = { priority: 'none', text: '', active: false };
    bannersArray.forEach(banner => {
      if (banner.active && !sessionStorage.getItem(banner.text) && this.isValid(banner) && severity[banner.priority] > severity[activeBanner.priority]) {
        activeBanner = banner;
      }
    });

    this.banner = activeBanner;
    this.alertType = activeBanner.type;
    this.content = activeBanner.text;
    this.active = activeBanner.active;
    this.dispatchEvent(new CustomEvent('bannerReady'));
  }

  isValid(banner) {
    const splitTitle = banner.title.split(',');
    let valid = false;
    splitTitle.forEach(title => {
      if (this.path.toLowerCase().includes(title) || title.includes('website')) {
        valid = true;
      }
    });
    return valid;
  }

  parseChariotContent(entry) {
    return entry.map(contentSection => ({
      title: contentSection[3].values[0].value.toLowerCase(),
      active: contentSection[0].values[0].value,
      priority: contentSection[2].values[0].value.toLowerCase(),
      type: contentSection[1].values[0].value.toLowerCase(),
      text: contentSection[4].values[0].value,
    }));
  }

  bannerClosed() {
    this.active = false;
    sessionStorage.setItem(this.banner.text, 'shown');
  }
}

export { RefiBanner };
